import { AMOUNT_PATTERN } from "@components/common/amount";
import { VALIDATION_ERRORS } from "../../errors";
import { Yup } from "../../yup";
import { getStringSelectionRequiredSchema } from "../strings";
import i18n from "i18next";
const NUMBER_PATTERN = /^[0-9]*$/;

export const getLandingSchema = () => {
  return Yup.object().shape({
    vehicleData: Yup.object().shape({
      model: Yup.object().shape({
        manufacturer: getStringSelectionRequiredSchema(i18n.t("landing:vehicleSection:fields:brand:label")),
        name: Yup.string().required(VALIDATION_ERRORS.inputRequired(i18n.t("landing:vehicleSection:fields:modelShort:label"))),
        descriptionLong: Yup.string().required(VALIDATION_ERRORS.inputRequired(i18n.t("landing:vehicleSection:fields:modelShort:label"))),
        year: Yup.string().required(VALIDATION_ERRORS.inputRequired(i18n.t("landing:vehicleSection:fields:year:label"))).matches(NUMBER_PATTERN, VALIDATION_ERRORS.valueInvalid),
        code: Yup.string().required(VALIDATION_ERRORS.inputRequired(i18n.t("landing:vehicleSection:fields:modelTypeKey:label"))),
      }),
      recommendedRetailPriceAmount: Yup.object().shape({
        amount: Yup.string().required(VALIDATION_ERRORS.inputRequired(i18n.t("landing:vehicleSection:fields:priceList:label"))).matches(AMOUNT_PATTERN, VALIDATION_ERRORS.valueInvalid),
      }),
      retailPriceAmount: Yup.object().shape({
        amount: Yup.string().required(VALIDATION_ERRORS.inputRequired(i18n.t("landing:vehicleSection:fields:price:label"))).matches(AMOUNT_PATTERN, VALIDATION_ERRORS.valueInvalid),
      }),
      isUsed: Yup.string().required(VALIDATION_ERRORS.inputRequired(i18n.t("landing:vehicleSection:fields:usedCar:label"))),
      deliveryData: Yup.object().shape({
        deliveryDate: Yup.string().required(VALIDATION_ERRORS.inputRequired(i18n.t("landing:vehicleSection:fields:deliveryDate:label"))),
      }),
       vin: Yup.string().when("isUsed", {
        is: "USED",
        then: (schema) =>
          schema.required(VALIDATION_ERRORS.inputRequired(i18n.t("landing:vehicleSection:fields:vin:label"))),
      }),
      initialRegistrationDate: Yup.string().when("isUsed", {
        is: "USED",
        then: (schema) =>
          schema.required(VALIDATION_ERRORS.inputRequired(i18n.t("landing:vehicleSection:fields:firstRegistrationDate:label"))),
      }),
      odometer: Yup.string().when("isUsed", {
        is: "USED",
        then: (schema) =>
          schema.required(VALIDATION_ERRORS.inputRequired(i18n.t("landing:vehicleSection:fields:mileage:label"))).matches(NUMBER_PATTERN, VALIDATION_ERRORS.valueInvalid),
      }),
      orderDate: Yup.string().required(VALIDATION_ERRORS.inputRequired(i18n.t("landing:vehicleSection:fields:orderDate:label"))),
    }),
  });
};
